<section class="bm-card bm-card-body bm-card-sm bm-card-border border-base-300">
  <h3 class="bm-card-title bm-card-title-top bg-base-100">
    Status
    <button class="bm-btn bm-btn-ghost bm-btn-sm bm-btn-square" (click)="openAddStatusForm()">
      <fa-icon [icon]="['far', 'plus']" />
    </button>
  </h3>

  <table class="bm-table bm-table-xs">
    <tbody>
      @for (status of project.status; track $index) {
        <tr>
          <th class="editable" (click)="openEditStatusForm(status)">
            {{ status.name }}
            @if (status.closed) {
              <fa-icon [tooltip]="'Closed'" [icon]="faCheckCircle" />
            }
            @if (status.canceled) {
              <fa-icon class="text-danger" [tooltip]="'Canceled'" [icon]="faBan" />
            }
            @if (status.visible_app) {
              <fa-icon class="text-info" [tooltip]="'Sichtbar in App'" [icon]="faMobileAlt" />
            }
            @if (status.report_closed) {
              <fa-icon class="text-muted" [tooltip]="'Report closed'" [icon]="faHandPaper" />
            }
          </th>
          <td>
            @if (status.mail_template) {
              {{ status.mail_template.subject }}
              @if (status.email) {
                ({{ status.email }})
              }
            }
          </td>
          <td style="white-space: nowrap">Tickets: {{ status.ticket_amount }}</td>
          <td style="white-space: nowrap">ID: {{ status.id }}</td>
          <td style="text-align: right">
            @if (!status.ticket_amount) {
              <fa-icon class="bm-cursor-pointer" [icon]="faTrash" (click)="deleteStatus(status)"></fa-icon>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</section>
<!--<section>
<h2 class="flex_row">
  Aufgaben
  <div class="pseudo-link" (click)="openAddTaskForm()">+ hinzufügen</div>
</h2>
<table class="section_table" style="font-size: 14px;">
  <tbody>
    <tr *ngFor="let task of project.tasks">
      <th class="editable" (click)="openEditTaskForm(task)">{{task.name}}</th>
      <td style="white-space: nowrap;">Tickets: {{task.ticket_amount}}</td>
      <td style="white-space: nowrap;">ID: {{task.id}}</td>
      <td style="text-align: right;"><fa-icon *ngIf="!task.ticket_amount" [icon]="faTrash"></fa-icon></td>
    </tr>
  </tbody>
</table>
</section>-->
<section class="bm-card bm-card-body bm-card-sm bm-card-border border-base-300">
  <h3 class="bm-card-title bm-card-title-top bg-base-100">
    Priorität
    <button class="bm-btn bm-btn-ghost bm-btn-sm bm-btn-square" (click)="openAddPriorityForm()">
      <fa-icon [icon]="['far', 'plus']" />
    </button>
  </h3>
  <table class="bm-table bm-table-xs" style="font-size: 14px">
    <tbody>
      @for (priority of project.priorities; track $index) {
        <tr>
          <th class="editable" (click)="openEditPriorityForm(priority)">
            <div class="flex_row">
              <div
                style="width: 16px; height: 16px; border: 1px solid black; border-radius: 8px; margin: auto 0"
                [style.background-color]="priority.color"
              ></div>
              <div style="margin: auto 4px">{{ priority.name }}</div>
            </div>
          </th>
          <td>Tickets: {{ priority.ticket_amount }}</td>
          <td>ID: {{ priority.id }}</td>
          <td style="text-align: right">
            @if (!priority.ticket_amount) {
              <fa-icon [icon]="faTrash" (click)="deletePriority(priority)"></fa-icon>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</section>

@if (addPriorityForm) {
  <hawk-add-new-priority-modal
    [formGroup]="addPriorityForm"
    (newDBOutput)="onProjectDataChange($event)"
    (closeModal)="addPriorityForm = null"
  />
}
@if (addStatusForm) {
  <hawk-add-new-status-modal
    [project]="project"
    [formGroup]="addStatusForm"
    (newDBOutput)="onProjectDataChange($event)"
    (closeModal)="addStatusForm = null"
  />
}
@if (addTaskForm) {
  <hawk-add-new-task-modal [formGroup]="addTaskForm" (closeModal)="addTaskForm = null" />
}
@if (editPriorityForm) {
  <hawk-edit-priority-modal
    [formGroup]="editPriorityForm"
    (newDBOutput)="onProjectDataChange($event)"
    (closeModal)="editPriorityForm = null"
  />
}
@if (editStatusForm) {
  <hawk-edit-status-modal
    [project]="project"
    [formGroup]="editStatusForm"
    (newDBOutput)="onProjectDataChange($event)"
    (closeModal)="editStatusForm = null"
  />
}
@if (editTaskForm) {
  <hawk-edit-task-modal [formGroup]="editTaskForm" (closeModal)="editTaskForm = null" />
}
